import { serializable, primitive, alias, object } from 'serializr';
import { OrganizationYearWise } from './organisationYearWise.model';
import { Sector } from './sector.model';
import { CompanyType } from './companyType.model';
import { Size } from './size.model';

export class OrganizationCompany {
  @serializable
  id?: number;

  @serializable
  name?: string;

  @serializable(alias('reporting_month', primitive()))
  reportingMonth?: number | string;

  @serializable(alias('baseline_year', primitive()))
  baselineYear?: number;

  @serializable(alias('recalculation_threshold', primitive()))
  recalculationThreshold?: number;

  @serializable(alias('organizational_boundary', primitive()))
  organizationalBoundary?: string;
}

export class Organization {
  @serializable(primitive())
  id?: number;

  @serializable(primitive())
  name?: string;

  @serializable(alias('is_parent', primitive()))
  isParent?: boolean;

  @serializable(alias('is_active', primitive()))
  isActive?: boolean;

  @serializable(alias('organization_share', primitive()))
  organizationShare?: number;

  @serializable(primitive())
  year?: number;

  @serializable(object(Size))
  size?: Size;

  @serializable(object(Sector))
  sector?: Sector;

  @serializable(alias('company_type', object(CompanyType)))
  companyType?: CompanyType;

  @serializable(object(OrganizationCompany))
  company?: OrganizationCompany;

  @serializable(alias('organization_year_wise', object(OrganizationYearWise)))
  organisationYearWise?: OrganizationYearWise;
}
